module.exports = __webpack_public_path__ + "img/qr_website.8452091b.png";